exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text_style{font-size:14px;color:#ee0a24}.money_xl{font-size:14px;font-weight:700}.money_xxl{font-size:20px;font-weight:700}", ""]);

// exports
